import { API, graphqlOperation, Auth, Cache } from 'aws-amplify';
import { executeTransactSql } from '@/graphql/mutations';
import { ENV } from '@/assets/js/const';
/**
 * 操作ログの登録
 * @param {*} logLevel 
 * @param {*} param 
 * @param {*} e
 */
export async function addLog(logLevel, param, componentName, methodName, typeName, e=null) {
  // console.log({logLevel});
  // console.log({param});
  // console.log({componentName});
  // console.log({methodName});
  // console.log({typeName});
  // console.log({e});
  // メソッド名を定義
  // const method_name="addLog"

  // 開発環境以外ではDEBUG・INFOログを出力しない
  switch (ENV) {
    case 'develop':
      break;
    case 'staging':
    case 'production':
      if (logLevel == 'DEBUG' || logLevel == 'INFO')
      return;
      break;
    default:
      break;
  }

  // エラーデータ
  if( e != null ) {
    let errorInfo = e.message ?? e.stack ?? {};
    if(errorInfo) Object.assign( param, { error_info: errorInfo } );
  }

  // Cookieに保存しているバージョン取得
  try {
    const versionCache = Cache.getItem('version');
    Object.assign( param, { version: versionCache } );
  } catch (error) {
    // 何もしない
  }

  // Cognitoユーザーデータ
  let user = null;
  // ログイン済みフラグ
  let isLoggedIn = true;
  try {
    const cognitoUser = await Auth.currentAuthenticatedUser();
    user = cognitoUser.username;
  } catch (error) {
    // 未ログイン
    isLoggedIn = false;
  }

  // let input = {
  //   LOG_LEVEL: logLevel,
  //   COMPONENT_NAME: componentName,
  //   METHOD_NAME: methodName,
  //   TYPE_NAME: typeName,
  //   MESSAGE_NAME: JSON.stringify(param),
  //   USER_NAME: user,
  //   USER_AGENT_NAME: window.navigator.userAgent.toLowerCase(),
  //   CREATE_USER_NAME: user,
  //   UPDATE_USER_NAME: user,
  // };


  let insertSQL = '';
  insertSQL += "INSERT INTO T_LOG (";
  insertSQL += "TIMESTAMP_TIME, ";
  insertSQL += "LOG_LEVEL, ";
  insertSQL += "COMPONENT_NAME, ";
  insertSQL += "METHOD_NAME, ";
  insertSQL += "TYPE_NAME, ";
  insertSQL += "MESSAGE_NAME, ";
  insertSQL += "USER_NAME, ";
  insertSQL += "USER_AGENT_NAME, ";
  insertSQL += "CREATE_USER_NAME, ";
  insertSQL += "CREATE_DATE, ";
  insertSQL += "UPDATE_USER_NAME, ";
  insertSQL += "UPDATE_DATE) ";
  insertSQL += "VALUES (";
  insertSQL += "CURRENT_TIMESTAMP(), ";
  insertSQL += `'${logLevel}', `;
  insertSQL += `'${componentName}', `;
  insertSQL += `'${methodName}', `;
  insertSQL += `'${typeName}', `;
  insertSQL += `'${JSON.stringify(param).replace(/'/g, '"')}', `;
  insertSQL += `'${user}', `;
  insertSQL += `'${window.navigator.userAgent.toLowerCase()}', `;
  insertSQL += `'${user}', `;
  insertSQL += "CURDATE(), ";
  insertSQL += `"${user}", `;
  insertSQL += "CURDATE());";

  try {
    if (isLoggedIn) {
      //await API.graphql(graphqlOperation( createT_LOG, { createT_LOGInput: input } ));

      await executeSql(isLoggedIn, insertSQL);
    } else {
      // 未ログインの場合はIAM認証モードでAPIを実行
      // await API.graphql({
      //   query: createT_LOG,
      //   variables: { createT_LOGInput: input },
      //   authMode: 'AWS_IAM'
      // });

      await executeSql(isLoggedIn, insertSQL);
    }
  } catch(error) {
    // 何もしない。
    console.error('addLog log output error', error);
  }
}

async function executeSql(isLoggedIn, insertSQL) {
  let condition = {
    SQLs: [insertSQL],
  };

  // データ取得
  try {
    // AppSync→AuroraServerless(MySQL)でデータ取得
    let result;
    if(isLoggedIn) {
      result = await API.graphql(
        graphqlOperation(executeTransactSql, condition)
      );
    } else {
      result = await API.graphql({
        query: executeTransactSql,
        variables: condition,
        authMode: 'AWS_IAM'
      });
    }

    // レスポンスデータを取得できた際の処理
    if (result) {
      const responseBody = JSON.parse(
        result.data.executeTransactSql.body
      );

      // SQL実行でエラーが発生した場合の処理
      if (result.data.executeTransactSql.statusCode > 200) {
        console.info({ responseBody });
        // レスポンスメッセージ
        let message = responseBody.message;
        console.error({ message });
        // エラー内容
        const errorMessage = responseBody.error;
        console.error('error on executeTransactSql', errorMessage);
        return false;
      } else {
        // SQLが正常に終了した際の処理
        if (responseBody.data) {
          // 結果はresponseBody.dataとして返却される
          console.info('responseBody.data', responseBody.data[0]);
        }
      }
    } else {
      // ログ出力(Lamda関数でのSQL実行でエラー)
      // addLog('ERROR', {message: MSG.ERROR["3008"], query: "executeTransactSql", where_option:condition}, this.$route.name, method_name, TYPE["0003"],);
      console.error('error on addLog no result');
      return false;
    }
  } catch (error) {
    console.error("insertTable : 異常終了 = " + JSON.stringify(error));
    return false;
  }
}
